
import { useState, useCallback } from 'react';
import { ExitCondition } from '../../types';

export const useExitConditions = (initialExitConditions?: ExitCondition[] | any) => {
  const [exitConditions, setExitConditions] = useState<ExitCondition[]>(() => {
    if (Array.isArray(initialExitConditions)) {
      return initialExitConditions;
    }
    return [];
  });

  const addExitCondition = useCallback((type: string, threshold: string, operator: string) => {
    // Convert threshold to a number if needed
    const numericValue = parseFloat(threshold);
    const exitCondition: ExitCondition = {
      id: Date.now().toString(),
      type,
      value: isNaN(numericValue) ? 0 : numericValue,
      threshold,
      operator
    };
    
    setExitConditions(prev => [...prev, exitCondition]);
  }, []);

  const removeExitCondition = useCallback((id: string) => {
    setExitConditions(prev => prev.filter(condition => condition.id !== id));
  }, []);

  const updateExitCondition = useCallback((id: string, changes: Partial<ExitCondition>) => {
    setExitConditions(prev => prev.map(condition => {
      if (condition.id === id) {
        return { ...condition, ...changes };
      }
      return condition;
    }));
  }, []);

  return {
    exitConditions,
    addExitCondition,
    removeExitCondition,
    updateExitCondition
  };
};
